module.exports = __webpack_public_path__ + "static/media/arrow.c6b78acf.svg";